import React, { useCallback } from 'react';

import { useSelector } from 'react-redux';

import { ActivityEntry } from 'src/components/activity/types';
import { CommentThread } from 'src/components/conversation/src/components/comment-tree';
import { useConversationsContext } from 'src/contexts/conversations-context';
import { getGlobalIsColorBlindModeEnabled } from 'src/redux/diff-settings';
import { getSyntaxHighlightingEnabled } from 'src/selectors/feature-selectors';
import { publishUiEvent } from 'src/utils/analytics/publish';

import {
  ConversationWithContext,
  RenderConversationOptions,
} from '../../containers/comments-dialog/conversation-with-context';

export function PullRequestCommentEntry(props: {
  event: CommentThread;
  /* eslint react/no-unused-prop-types: warn */
  actor: ActivityEntry['actor'];
  timestamp: ActivityEntry['timestamp'];
}): JSX.Element {
  const { activityFeedVersion } = useConversationsContext();
  const handleFileExpandCollapse = useCallback(
    (isExpanded: boolean) => {
      publishUiEvent({
        action: 'clicked',
        actionSubject: 'fileCollapseExpandButton',
        actionSubjectId: isExpanded ? 'expand' : 'collapse',
        source: 'prView',
        attributes: {
          activityFeedVersion,
        },
      });
    },
    [activityFeedVersion]
  );

  const handlePermalinkClick = useCallback(() => {
    publishUiEvent({
      action: 'clicked',
      actionSubject: 'permalinkClick',
      actionSubjectId: 'comment',
      source: 'prView',
      attributes: {
        activityFeedVersion,
      },
    });
  }, [activityFeedVersion]);

  const meta = props.event.topComment.inline;
  const options: RenderConversationOptions = {
    isColorBlindModeEnabled: useSelector(getGlobalIsColorBlindModeEnabled),
    isSyntaxHighlightingEnabled: useSelector(getSyntaxHighlightingEnabled),
    canCollapseThread: true,
    canResolveThread: !!meta?.path,
    canCollapseFile: true,
    meta: {
      path: meta?.path,
      to: meta?.to || meta?.from || null,
    },
    handleFileExpandCollapse,
    handlePermalinkClick,
  };
  return (
    <ConversationWithContext commentThread={props.event} options={options} />
  );
}
